"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Builder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var childrenLimitTypeOptions = [{
  value: 'all',
  label: 'No random selection – show all elements in block'
}, {
  value: 'number',
  label: 'Randomly select a number of elements to show'
}, {
  value: 'percent',
  label: 'Randomly select a percentage of elements to show'
}];
var Builder = function Builder(props) {
  var _props$fields = props.fields,
    name = _props$fields.name,
    randomizeChildren = _props$fields.randomizeChildren,
    childrenLimitType = _props$fields.childrenLimitType,
    childrenLimit = _props$fields.childrenLimit;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
    field: name,
    label: "Name"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
    field: childrenLimit,
    label: "Random selection"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("select", _extends({
    className: "form-control",
    style: {
      width: 'auto'
    }
  }, (0, _domOnlyProps["default"])(childrenLimitType)), childrenLimitTypeOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })), ['number', 'percent'].includes(childrenLimitType.value) && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '0.4em 0',
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: "form-control"
  }, (0, _domOnlyProps["default"])(childrenLimit), {
    type: "number",
    min: "1",
    style: {
      width: '8rem',
      margin: '0.4em 0'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '0.6em 0.4em'
    }
  }, childrenLimitType.value === 'number' && 'elements', childrenLimitType.value === 'percent' && '%'))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkbox",
    style: {
      margin: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "checkbox"
  }, (0, _domOnlyProps["default"])(randomizeChildren))), " Randomize order of elements in block")));
};
exports.Builder = Builder;
Builder.propTypes = {
  fields: _propTypes["default"].object
};
var _default = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues,
  withBlock: true,
  withVisibilityConditions: true
})(Builder);
exports["default"] = _default;